import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { isEmpty } from 'lodash';
import { v4 as uuid } from 'uuid';
import cns from 'classnames';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';
import QuestionItems from './QuestionItemsComponent';

export default class QuestionsFieldArray extends Component {
    static propTypes = {
        fields: PropTypes.object.isRequired,
        categories: PropTypes.array.isRequired,
        displayType: PropTypes.string,
        disabled: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            hiddenQuestions: []
        };
    }

    _createTable = () => {
        const { fields, categories, displayType, disabled } = this.props;
        const { hiddenQuestions } = this.state;
        if (fields && fields.length > 0) {
            return (
                <div className={'row questions-table'}>
                    {fields.map((question, index) => (
                        <div className={'col-12'}>
                            {!hiddenQuestions.includes(index) ? (
                                <div className={'col-12'}>
                                    <Field
                                        name={`${question}.prompt`}
                                        label={'Question Prompt'}
                                        component={BasicText}
                                        disabled={disabled}
                                    />
                                    <FieldArray
                                        deleteQuestion={() => fields.remove(index)}
                                        name={`${question}.answers`}
                                        categories={categories}
                                        displayType={displayType}
                                        component={QuestionItems}
                                        disabled={disabled}
                                    />
                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    };

    render() {
        const { fields, categories, displayType, disabled } = this.props;
        const { hiddenQuestions } = this.state;

        const table = this._createTable();

        return (
            <div>
                {displayType && !isEmpty(categories) ? (
                    <div className={'permutationSectionQuestions'}>
                        <h4 className={'col-12'}>QUESTIONS</h4>
                        &nbsp;
                        <VerbButton
                            title={'Toggle Visibility All Questions'}
                            className={'collapse-expand-btn'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={hiddenQuestions.length === fields.length ? 'fa-caret-down' : 'fa-caret-up'}
                            buttonText={hiddenQuestions.length === fields.length ? 'Expand' : 'Collapse'}
                            onClick={() =>
                                hiddenQuestions.length === fields.length
                                    ? this.setState({ hiddenQuestions: [] })
                                    : this.setState({ hiddenQuestions: fields.map((_, i) => i) })
                            }
                        />
                        {table}
                        <VerbButton
                            className={cns('permutationSectionQuestionsButton', { hidden: disabled })}
                            buttonText={'Add Question'}
                            fontAwesomeIcon={'fa-plus'}
                            onClick={() => fields.push({ id: uuid(), prompt: null, image: null, category: null })}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}
